<template>
  <div class="idcs-list-container">
    <div class="jc-page-top">
      <div class="instance-list">
        <div class="jc-page-header">
          <h1>
            <i class="jc-icon-my-circle-bold"></i
            >{{ $t('idcs.title') }}
          </h1>
          <div class="jc-box-action"></div>
        </div>
        <div class="jc-page-content">
          <div class="el-container-table common-table-container">
            <div class="el-container-table-actionBar">
              <el-form class="el-table-actionBar-item" :inline="true">
                <el-form-item>
                  <el-button
                    icon="jc-icon-refresh-line"
                    class="el-button-icon"
                    @click="refreshList"
                    :disabled="refreshloading"
                  ></el-button>
                </el-form-item>
              </el-form>
              <el-form class="el-box-table-search" :inline="true" @submit.native.prevent>
                <el-form-item class="set-icon">
                  <el-button
                    icon="el-icon-setting"
                    class="el-button-icon"
                    @click="setCustom"
                    :title="$t('merge.customList')"
                  ></el-button>
                </el-form-item>
                <el-form-item>
                  <el-button
                    icon="jc-icon-download"
                    class="el-button-icon"
                    @click="exportList"
                    :title="$t('speechcraft.exportResourceList')"
                  ></el-button>
                </el-form-item>
              </el-form>
            </div>
            <div class="el-container-table">
              <el-table
                :data="tableData"
                tooltip-effect="light"
                ref="table"
                v-loading="refreshloading"
                :empty-text="tableEmptyTip"
              >
                <el-table-column
                  prop="datacenterNameShow"
                  key="datacenterNameShow"
                  min-width="200"
                  :label="$t('idcs.idcName')"
                  v-if="getCustomInfoSelect('datacenterNameShow')"
                >
                </el-table-column>
                <el-table-column
                  prop="regionShow"
                  key="regionShow"
                  min-width="180"
                  :label="$t('idcs.region')"
                  v-if="getCustomInfoSelect('regionShow')"
                >
                </el-table-column>
                <el-table-column
                  prop="address"
                  key="address"
                  min-width="440"
                  show-overflow-tooltip
                  :label="$t('idcs.address')"
                  v-if="getCustomInfoSelect('address')"
                >
                </el-table-column>
                <!-- <el-table-column
                  prop="managerPhone"
                  key="managerPhone"
                  min-width="160"
                  :label="$t('idcs.managerPhone')"
                  v-if="customInfo !== null && customInfo['managerPhone'].selected"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.managerPhone || "--" }}</span>
                  </template>
                </el-table-column> -->
              </el-table>
            </div>
          </div>
        </div>
        <custom
          :visible.sync="customVisible"
          v-if="customVisible"
          :optionArr="optionArr"
          :type="type"
        ></custom>
      </div>
    </div>
    <div class="el-page-footer block el-container-table-actionBar"
         v-if="tableData.length">
      <div></div>

      <el-pagination @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="currentPage"
                     :page-sizes="pageSizeArr"
                     :page-size="pageSize"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import custom from "../common/custom/Custom.vue";
import { ServiceCodeConstant } from '@/common/Constants';
import customInfoSelect from '@/mixins/customInfoSelect'

export default {
  name: "IdcsList",
  components: {
    custom,
  },
  mixins: [customInfoSelect],
  data() {
    return {
      resourceId: [],
      refreshloading: false,
      tableData: [],
      tableEmptyTip: "",
      tableEmptyMap: {
        noSearch: this.$t("text.noSearch"),
      },
      customVisible: false,
      type: "idc",
      optionArr: [
        { label: this.$t('idcs.idcName'), value: 'datacenterNameShow' },
        { label: this.$t('idcs.region'), value: 'regionShow' },
        { label: this.$t('idcs.address'), value: 'address' },
        // { label: this.$t('idcs.managerPhone'), value: 'managerPhone' },
      ],
      // 分页相关数据
      currentPage: 1, // 当前页数
      pageSize: 20, // 当前显示数据个数
      pageSizeArr: [20, 50, 100], // 每页显示总数
      total: 0, // 数据总数
    };
  },
  created() {
    if (!this.$store.state.customInfo[this.type]) {
      this.getCustomInfo();
    }
    this.refreshList();
  },
  computed: {
    ServiceCodeConstant: () => ServiceCodeConstant,
    customInfo () {
      return this.$store.state.customInfo[this.type];
    }
  },
  methods: {
    // 分页大小改变
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.refreshList();
    },
    // 当前页码改变
    handleCurrentChange(val) {
      this.currentPage = val;
      this.refreshList();
    },
    async refreshList() {
      this.refreshloading = true;
      try {
        const params = {
          all: 1, idcLine: this.GLOBAL.IDCLINE
        };
        const res = await this.$api.getComputerRoom(params);
        if (res && res.errno === 10000 && res.data && Array.isArray(res.data.idcs)) {
          const {idcs, totalCount} = res.data || {};
          this.tableData = res.data.idcs || [];
          this.total = totalCount || 0;
        } else {
          this.tableData = [];
          this.total = 0;
          this.tableEmptyTip = this.tableEmptyMap.noSearch;
        }
      } catch (e) {
        this.tableData = [];
        this.total = 0;
        this.tableEmptyTip = this.tableEmptyMap.noSearch;
      } finally {
        this.refreshloading = false;
      }
    },
    setCustom() {
      this.customVisible = true;
    },
    getCustomInfo () {
      const param = {
        pageKey: this.type
      };
      this.$api.getCustomInfo(param).then((response) => {
        // var response = JSON.parse(res)
        if (response.errno === 10000 && response.data.customInfo) {
          this.$store.commit('GET_CUSTOMINFO', { value: response.data.customInfo, type: this.type });
        }
      });
    },
    exportList() {
      let url = '/ccs-api/api/resource/exportIdcs';
      window.open(url, '_self');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./list.scss";
</style>



// WEBPACK FOOTER //
// src/components/idcs/IdcsList.vue